var _path, _line, _polyline, _polyline2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRoomSingle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,15.5H3.5a3,3,0,0,0-3,3v5h31v-5A3,3,0,0,0,28.5,15.5Z",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 20.5,
    x2: 31,
    y2: 20.5,
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.5 24 0.5 28.5 2.98 28.5 4.5 23.5",
    strokeMiterlimit: 10
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "31.5 24 31.5 28.5 29.02 28.5 27.5 23.5",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,4.5H9.5a6,6,0,0,0-6,6v5h25v-5A6,6,0,0,0,22.5,4.5Z",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,10.5a3,3,0,0,0-3-3H9.5a3,3,0,0,0-3,3",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10.5h-7a3,3,0,0,0-3,3v2h13v-2A3,3,0,0,0,19.5,10.5Z",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoomSingle);
export default __webpack_public_path__ + "static/media/icon-room-single.bb8acabdc1bfe652aad969299f4f60ff.svg";
export { ForwardRef as ReactComponent };